import React, { FC } from 'react';

import { Input, Skeleton, AssetWithIcon } from '@/shared/ui';
import { cn } from '@/shared/lib/tailwind-merge';

type AssetInputProps = {
    assetName: string;
    balance: number;
    value?: number;
    setValue: (value: number) => void;
    maxBorrowLoading?: boolean;
    disabled?: boolean;
    customTitle?: string;
    customBalanceLabel?: string;
    classes?: Partial<Record<AssetInputClasses, string>>;
    loading?: boolean;
};

type AssetInputClasses = 'root';

export const AssetInput: FC<AssetInputProps> = ({
    value,
    setValue,
    assetName,
    balance,
    classes,
    customBalanceLabel,
    customTitle,
    disabled,
    maxBorrowLoading,
}) => {
    const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) =>
        setValue(Number(e.target.value) || 0);
    const setMaxAmount = () => setValue(balance);

    return (
        <div
            className={cn(
                'bg-background-secondary border border-border-opaque rounded-md p-5 flex flex-col',
                classes?.root,
            )}
        >
            <div className='flex justify-between items-center text-content-secondary'>
                <span>{customTitle ?? 'You Deposit'}</span>
                <div className='flex items-center'>
                    <span
                        onClick={setMaxAmount}
                        className='text-content-primary underline cursor-pointer hover:text-content-accent transition'
                    >
                        {customBalanceLabel ?? 'Balance'}
                    </span>
                    <span className='ml-1'>
                        {maxBorrowLoading ? <Skeleton className='w-10 h-4' /> : `(${balance})`}
                    </span>
                </div>
            </div>
            <div className='flex items-center justify-between mt-3'>
                <AssetWithIcon
                    assetName={assetName || ''}
                    className='w-8 h-8 text-content-primary'
                />
                <Input
                    type='number'
                    min={0}
                    value={value}
                    onChange={handleAmountChange}
                    placeholder='0'
                    className='w-full pl-11 text-right text-lg border-none bg-transparent shadow-none focus:ring-0 text-content-primary'
                    disabled={disabled}
                />
            </div>
        </div>
    );
};
